export default __webpack_public_path__ + "static/media/cp.c84a71b9.png";